import Image from "next/image";

import { useCallback, useState } from "react";

import { twMerge } from "tailwind-merge";

import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faCube } from "@fortawesome/free-solid-svg-icons/faCube";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";

import AddToWatchlistButton from "components/AddToWatchlistButton";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import useMediaQuery from "hooks/useMediaQuery";
import { sectors } from "consts/sectors";

interface Props {
  entity: any;
}

export default function DashboardPageSuggestedEntitiesSnippet({
  entity,
}: Props) {
  const { mobile } = useMediaQuery();

  const { name, prettyName, shortSecurity } = entity;
  const icon = sectors.find((s) => s.name === entity?.sector)?.icon || faCube;

  const [show, toggleShow] = useState(true);

  const onAddedToWatchlists = useCallback(() => {
    setTimeout(() => {
      toggleShow(false);
    }, 1500);
  }, []);

  return (
    <AddToWatchlistButton entity={entity}>
      {({ addToWatchlist, isWatching, watchlists }) => {
        if (!show) return;

        if (isWatching) {
          onAddedToWatchlists();
        }

        return (
          <div
            className={twMerge(
              "flex flex-col justify-between",
              "!max-w-[100px] min-h-[200px] !min-w-[150px]",
              "p-[15px] border-[1px] border-solid border-[#00000022] rounded-[5px]"
            )}
          >
            <div className="flex flex-col text-center">
              <div className="flex items-center justify-center mb-[12px]">
                {entity?.logoUrl?.large ? (
                  <Image
                    className={twMerge(
                      "rounded-xl border-[1px] border-solid border-[#00000022]"
                    )}
                    src={entity?.logoUrl?.large}
                    width={mobile ? 50 : 150}
                    height={mobile ? 50 : 150}
                    alt={name}
                    priority
                  />
                ) : (
                  <div className="flex items-center justify-center bg-fern rounded-xl w-[50px] h-[50px] text-white">
                    <FontAwesomeIcon
                      icon={icon}
                      className="text-[30px] md:text-[130px]"
                    />
                  </div>
                )}
              </div>
              <h1 className="text-[14px] mb-0 truncate">{prettyName}</h1>
              <p className="text-[14px] text-intelligent-silver">
                {shortSecurity}
              </p>
            </div>
            <div className="flex justify-center">
              <div
                className={twMerge(
                  "text-smart-teal font-semibold px-[10px] hover:text-smart-teal text-[12px] rounded-full text-center leading-7 cursor-pointer border border-solid",
                  isWatching && "border-karma-green text-karma-green"
                )}
                onClick={addToWatchlist}
              >
                <FontAwesomeIcon
                  icon={isWatching ? faCheck : faPlus}
                  className="mr-[6.5px]"
                />
                <span>
                  {isWatching
                    ? `${watchlists.length} Watchlist${
                        watchlists.length > 1 ? "s" : ""
                      }`
                    : "Watchlist"}
                </span>
              </div>
            </div>
          </div>
        );
      }}
    </AddToWatchlistButton>
  );
}
